<template>
  <li
    class="parent-nav-item"
    :class="{ aside_active: isActive() || activeLink }"
    ref="sidebarRef"
    v-if="shouldShowParent"
  >
    <div class="item-parent-nav-item" v-if="link && link.type === 'search'">
      <span @click="toggleSearchPopup()">
        <i class="fas fa-search"></i>
        <h6 class="title fs-12 custom-h">
          {{ Lang.get(`messages.sidebar.${link.label}`) }}
        </h6>
      </span>

      <div class="child-nav-item" :class="{ show: showSearchPopup }">
        <h4 class="modal_title custom-h">
          {{ Lang.get(`messages.sidebar.${link.label}`) }}
        </h4>

        <!-- sub category content -->
        <ul
          class="accordion custom-ul child_list"
          :id="`accordionExample${link.label}`"
        >
          <li class="position-relative">
            <input
              type="search"
              id="searchInput"
              class="w-100"
              placeholder=""
              v-model="searchQuery"
            />
            <img
              src="/assets/front_end/assets/images/search.svg"
              class="search-icon position-absolute"
            />
          </li>
          <ul class="custom-ul mt-2" v-if="filteredSearchResults.length">
            <li
              v-for="(item, index) in filteredSearchResults"
              :key="item.label + index"
              class="dropdown-item d-flex justify-content-between align-items-center"
            >
              <div
                @click="addToLinkHistory(item)"
                class="flex-grow-1"
                style="cursor: pointer"
              >
                <h6 class="third-color m-0">
                  {{ Lang.get(`messages.sidebar.${item.label}`) }}
                </h6>
              </div>
              <img
                src="/assets/front_end/assets/images/close-circle.svg"
                v-if="item.id"
                @click="removeSearchResult(index, item)"
                style="filter: grayscale(1); cursor: pointer"
              />
            </li>
          </ul>
          <ul class="custom-ul mt-2" v-else>
            <li class="dropdown-item">
              <h6 class="third-color m-0">
                {{ Lang.get("messages.sidebar.no_search_results") }}
              </h6>
            </li>
          </ul>
        </ul>
      </div>
    </div>
    <div class="item-parent-nav-item" v-else-if="link && link.type === 'group'">
      <span @click="toggleDropdown(link)">
        <i :class="[link.icon, 'fs-24']"></i>

        <h6 class="title fs-12 custom-h">
          {{ Lang.get(`messages.sidebar.${link.label}`) }}
        </h6>
      </span>
      <div
        class="child-nav-item modal-container"
        :class="{ show: currentOpenGroup === link.label }"
      >
        <h4 class="modal_title custom-h">
          {{ Lang.get(`messages.sidebar.${link.label}`) }}
          <!--          <span class="close_modal_icon" @click="closeAll">x</span>-->
        </h4>

        <!-- sub category content -->
        <ul
          class="accordion custom-ul child_list"
          :id="`accordionExample${slugify(link.label)}`"
        >
          <li
            class="card"
            v-for="(child, index) in link.children"
            :key="child.label + index"
            v-if="hasVisibleChildren(child.children)"

          >
            <div
              class="card-header"
              :id="`heading-${slugify(child.label)}-${index}`"
            >
              <button
                class="btn btn-link w-100"
                data-toggle="collapse"
                :data-target="`#collapse-${slugify(child.label)}-${index}`"
                :aria-controls="`collapse-${slugify(child.label)}-${index}`"
                aria-expanded="true"
              >
                <h6 class="child-title fw-500 fs-16 custom-h">
                  {{ Lang.get(`messages.sidebar.${child.label}`) }}
                </h6>
              </button>
            </div>
            <div
              class="collapse show"
              :id="`collapse-${slugify(child.label)}-${index}`"
              :aria-labelledby="`heading-${slugify(child.label)}-${index}`"
            >
              <div class="card-body">
                <ul class="sub_category_list custom-ul">
                  <li
                    class="card"
                    v-for="sub_child in child.children"
                    :key="sub_child.label + index"
                    v-if="sub_child.children && sub_child.children.length > 0 && (sub_child.permission ? canAny(sub_child.permission) : true)"
                  >
                    <div
                      class="card-header"
                      :id="`heading-${slugify(sub_child.label)}`"
                    >
                      <button
                        class="btn btn-link w-100"
                        data-toggle="collapse"
                        :data-target="`#collapse-${slugify(sub_child.label)}`"
                        aria-expanded="false"
                        :aria-controls="`collapse-${slugify(sub_child.label)}`"
                      >
                        <h6 class="child-title fw-500 fs-16 custom-h">
                          {{ Lang.get(`messages.sidebar.${sub_child.label}`) }}
                        </h6>
                      </button>
                    </div>
                    <div
                      :id="`collapse-${slugify(sub_child.label)}`"
                      class="collapse show"
                      :aria-labelledby="`heading-${slugify(sub_child.label)}`"
                    >
                      <div class="card-body">
                        <ul class="sub_category_list custom-ul">
                          <!-- aside_active to active li  -->
                          <li
                            class="d-flex align-items-center justify-content-between"
                            v-for="innerChild in sub_child.children"
                            :key="innerChild.label + index"
                            v-if="innerChild.permission ? canAny(innerChild.permission) : true"
                            :class="{ aside_active: isLinkActive(innerChild) }"
                          >
                            <router-link
                              :to="{
                                path: innerChild.path,
                                query: innerChild.query,
                              }"
                              class="fw-500 custom-h child-item-title"
                            >
                              {{
                                Lang.get(`messages.sidebar.${innerChild.label}`)
                              }}</router-link
                            >

                            <svg
                              class="fav_icon"
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="23"
                              viewBox="0 0 22 23"
                              fill="none"
                              v-if="checkItemInFav(innerChild.path)"
                              @click="
                                removeFromFav(checkItemInFav(innerChild.path))
                              "
                            >
                              <path
                                d="M16.6477 2.35962L16.2956 3.74617C18.7979 5.41978 20.448 8.27143 20.448 11.5004C20.448 16.57 16.3805 20.7098 11.3352 20.8199L10.2619 22.1478C10.5463 22.1713 10.8342 22.183 11.1258 22.183C17.0169 22.183 21.8093 17.3896 21.8093 11.4995C21.8093 7.6278 19.7412 4.23182 16.6495 2.35871L16.6477 2.35962ZM1.80178 11.5004C1.80178 6.42901 5.87298 2.29011 10.9164 2.17908L11.987 0.8521C11.7026 0.82863 11.4147 0.816895 11.1249 0.816895C5.23477 0.816895 0.441406 5.60845 0.441406 11.5004C0.441406 15.3721 2.51221 18.7681 5.60307 20.6412L5.95422 19.2528C3.45192 17.5792 1.80178 14.7294 1.80178 11.5004Z"
                                fill="#1BC6D1"
                              />
                              <path
                                d="M17.8081 9.86836C17.6925 9.62644 17.4632 9.48201 17.196 9.48201H13.3397L15.5269 0.850347C15.5811 0.636406 15.5432 0.436909 15.4159 0.274422C15.2823 0.102908 15.0729 0 14.8553 0C14.654 0 14.4753 0.088465 14.3399 0.256368L4.52657 12.4113C4.35776 12.6198 4.32617 12.8888 4.44171 13.1307C4.55545 13.3691 4.79106 13.5171 5.05465 13.5171H8.9101L6.72285 22.1497C6.66868 22.3636 6.7066 22.5631 6.83388 22.7265C6.96658 22.898 7.176 23 7.39355 23C7.59486 23 7.77359 22.9115 7.9099 22.7427L17.7232 10.5878C17.8893 10.3829 17.9218 10.1067 17.8072 9.86836H17.8081Z"
                                fill="#1BC6D1"
                              />
                            </svg>

                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="22"
                              height="23"
                              viewBox="0 0 22 23"
                              fill="none"
                              v-else
                              @click="addToFav(innerChild)"
                            >
                              <path
                                d="M16.6477 2.35962L16.2956 3.74617C18.7979 5.41978 20.448 8.27143 20.448 11.5004C20.448 16.57 16.3805 20.7098 11.3352 20.8199L10.2619 22.1478C10.5463 22.1713 10.8342 22.183 11.1258 22.183C17.0169 22.183 21.8093 17.3896 21.8093 11.4995C21.8093 7.6278 19.7412 4.23182 16.6495 2.35871L16.6477 2.35962ZM1.80178 11.5004C1.80178 6.42901 5.87298 2.29011 10.9164 2.17908L11.987 0.8521C11.7026 0.82863 11.4147 0.816895 11.1249 0.816895C5.23477 0.816895 0.441406 5.60845 0.441406 11.5004C0.441406 15.3721 2.51221 18.7681 5.60307 20.6412L5.95422 19.2528C3.45192 17.5792 1.80178 14.7294 1.80178 11.5004Z"
                                fill="#5d5d5d"
                              />
                              <path
                                d="M17.8081 9.86836C17.6925 9.62644 17.4632 9.48201 17.196 9.48201H13.3397L15.5269 0.850347C15.5811 0.636406 15.5432 0.436909 15.4159 0.274422C15.2823 0.102908 15.0729 0 14.8553 0C14.654 0 14.4753 0.088465 14.3399 0.256368L4.52657 12.4113C4.35776 12.6198 4.32617 12.8888 4.44171 13.1307C4.55545 13.3691 4.79106 13.5171 5.05465 13.5171H8.9101L6.72285 22.1497C6.66868 22.3636 6.7066 22.5631 6.83388 22.7265C6.96658 22.898 7.176 23 7.39355 23C7.59486 23 7.77359 22.9115 7.9099 22.7427L17.7232 10.5878C17.8893 10.3829 17.9218 10.1067 17.8072 9.86836H17.8081Z"
                                fill="#5d5d5d"
                              />
                            </svg>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li
                    class="d-flex align-items-center justify-content-between"
                    :class="{ aside_active: isLinkActive(sub_child) }"
                    v-else-if="sub_child.permission ? canAny(sub_child.permission):true"
                  >
                    <router-link
                      :to="{ path: sub_child.path, query: sub_child.query }"
                      class="fw-500 custom-h child-item-title"
                    >
                      {{
                        Lang.get(`messages.sidebar.${sub_child.label}`)
                      }}</router-link
                    >

                    <svg
                      class="fav_icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="23"
                      viewBox="0 0 22 23"
                      fill="none"
                      v-if="checkItemInFav(sub_child.path)"
                      @click="removeFromFav(checkItemInFav(sub_child.path))"
                    >
                      <path
                        d="M16.6477 2.35962L16.2956 3.74617C18.7979 5.41978 20.448 8.27143 20.448 11.5004C20.448 16.57 16.3805 20.7098 11.3352 20.8199L10.2619 22.1478C10.5463 22.1713 10.8342 22.183 11.1258 22.183C17.0169 22.183 21.8093 17.3896 21.8093 11.4995C21.8093 7.6278 19.7412 4.23182 16.6495 2.35871L16.6477 2.35962ZM1.80178 11.5004C1.80178 6.42901 5.87298 2.29011 10.9164 2.17908L11.987 0.8521C11.7026 0.82863 11.4147 0.816895 11.1249 0.816895C5.23477 0.816895 0.441406 5.60845 0.441406 11.5004C0.441406 15.3721 2.51221 18.7681 5.60307 20.6412L5.95422 19.2528C3.45192 17.5792 1.80178 14.7294 1.80178 11.5004Z"
                        fill="#1BC6D1"
                      />
                      <path
                        d="M17.8081 9.86836C17.6925 9.62644 17.4632 9.48201 17.196 9.48201H13.3397L15.5269 0.850347C15.5811 0.636406 15.5432 0.436909 15.4159 0.274422C15.2823 0.102908 15.0729 0 14.8553 0C14.654 0 14.4753 0.088465 14.3399 0.256368L4.52657 12.4113C4.35776 12.6198 4.32617 12.8888 4.44171 13.1307C4.55545 13.3691 4.79106 13.5171 5.05465 13.5171H8.9101L6.72285 22.1497C6.66868 22.3636 6.7066 22.5631 6.83388 22.7265C6.96658 22.898 7.176 23 7.39355 23C7.59486 23 7.77359 22.9115 7.9099 22.7427L17.7232 10.5878C17.8893 10.3829 17.9218 10.1067 17.8072 9.86836H17.8081Z"
                        fill="#1BC6D1"
                      />
                    </svg>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="23"
                      viewBox="0 0 22 23"
                      fill="none"
                      v-else
                      @click="addToFav(sub_child)"
                    >
                      <path
                        d="M16.6477 2.35962L16.2956 3.74617C18.7979 5.41978 20.448 8.27143 20.448 11.5004C20.448 16.57 16.3805 20.7098 11.3352 20.8199L10.2619 22.1478C10.5463 22.1713 10.8342 22.183 11.1258 22.183C17.0169 22.183 21.8093 17.3896 21.8093 11.4995C21.8093 7.6278 19.7412 4.23182 16.6495 2.35871L16.6477 2.35962ZM1.80178 11.5004C1.80178 6.42901 5.87298 2.29011 10.9164 2.17908L11.987 0.8521C11.7026 0.82863 11.4147 0.816895 11.1249 0.816895C5.23477 0.816895 0.441406 5.60845 0.441406 11.5004C0.441406 15.3721 2.51221 18.7681 5.60307 20.6412L5.95422 19.2528C3.45192 17.5792 1.80178 14.7294 1.80178 11.5004Z"
                        fill="#5d5d5d"
                      />
                      <path
                        d="M17.8081 9.86836C17.6925 9.62644 17.4632 9.48201 17.196 9.48201H13.3397L15.5269 0.850347C15.5811 0.636406 15.5432 0.436909 15.4159 0.274422C15.2823 0.102908 15.0729 0 14.8553 0C14.654 0 14.4753 0.088465 14.3399 0.256368L4.52657 12.4113C4.35776 12.6198 4.32617 12.8888 4.44171 13.1307C4.55545 13.3691 4.79106 13.5171 5.05465 13.5171H8.9101L6.72285 22.1497C6.66868 22.3636 6.7066 22.5631 6.83388 22.7265C6.96658 22.898 7.176 23 7.39355 23C7.59486 23 7.77359 22.9115 7.9099 22.7427L17.7232 10.5878C17.8893 10.3829 17.9218 10.1067 17.8072 9.86836H17.8081Z"
                        fill="#5d5d5d"
                      />
                    </svg>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="item-parent-nav-item 2" v-else-if="link.permission ? canAny(link.permission) : true">
      <i :class="[link.icon, 'fs-24']"></i>
      <router-link
        :to="{ path: link.path, query: link.query }"
        class="title fs-12 custom-h stretched-link"
      >
        {{ Lang.get(`messages.sidebar.${link.label}`) }}</router-link
      >
    </div>
  </li>
  <!-- First level children -->
</template>

<script>
import eBus from "@/event-bus";
import { mapState } from "vuex";
export default {
  name: "SidebarItem",
  props: {
    link: Object,
    index: [Number, String],
    links: {
      type: Array,
      default: () => [],
    },
    fav_list: {
      type: Array,
      default: () => [],
    },
    history_list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState("users", ["user"]),
    shouldShow() {
      return this.isActive() || this.hasActiveChild;
    },
    activeLink() {
      const checkActive = (items) => {
        return items.some((item) => {
          if (this.$route.path === item.path) return true;
          if (this.$route.name === item.name) return true;
          if (item.children) return checkActive(item.children);
          return false;
        });
      };

      return this.link.children ? checkActive(this.link.children) : false;
    },
    hasActiveChild() {
      // Handle type='group' items with children
      if (this.link.type === "group" && this.link.children) {
        return this.link.children.some((child) => this.isChildActive(child));
      }
      return false;
    },
    filteredSearchResults() {
      const query = this.searchQuery.toLowerCase().trim();

      if (!query) {
        // if no search query, show last 10 history items (most recent first) - filtered by permission
        return [...this.history_list]
          .filter(item => item.permission ? this.can(item.permission) : true)
          .slice(-10)
          .reverse();
      }

      const results = [];
      const uniquePaths = new Set();

      // 🔹 define helper function INSIDE filteredSearchResults
      const searchNodes = (nodes = []) => {
        nodes.forEach((node) => {
          // Check permission first
          const hasPermission = node.permission ? this.can(node.permission) : true;

          const text =
            this.Lang.get(`messages.sidebar.${node.label}`)?.toLowerCase() ||
            "";

          // match condition - now includes permission check
          if (
            hasPermission &&
            text.includes(query) &&
            node.path &&
            !uniquePaths.has(node.path)
          ) {
            uniquePaths.add(node.path);
            results.push(node);
          }

          // if node has children, go deeper recursively
          if (node.children && node.children.length > 0) {
            searchNodes(node.children);
          }
        });
      };

      // start recursion from top-level links
      this.links.forEach((link) => {
        if (link.children) {
          searchNodes(link.children);
        }
      });

      return results.slice(-10).reverse();
    },
    // NEW: Check if parent should be shown based on children permissions
    shouldShowParent() {
      // Always show search type
      if (this.link && this.link.type === 'search') {
        return true;
      }

      // For group type, check if any children are visible
      if (this.link && this.link.type === 'group' && this.link.children) {
        return this.hasVisibleChildren(this.link.children);
      }

      // For regular links, check their own permission
      return this.link.permission ? this.can(this.link.permission) : true;
    },
  },

  data() {
    return {
      isOpen: false,
      showSearchPopup: false,
      searchQuery: "",
      currentOpenGroup: null,
    };
  },
  watch: {
    $route: {
      handler() {
        this.closeAll();
      },
      immediate: false,
    },
  },
  methods: {
    slugify(value) {
      return value
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w-]/g, "");
    },
    toggleDropdown(link) {
      if (this.currentOpenGroup === link.label && this.isOpen) {
        // If already open, close it
        this.currentOpenGroup = null;
        this.isOpen = false;
        return;
      }

      // Otherwise, close all and open this one
      eBus.$emit("close-all-dropdowns");
      this.currentOpenGroup = link.label;
      this.showSearchPopup = false;
      this.isOpen = true;
    },
    closeAll() {
      this.currentOpenGroup = null;
      this.showSearchPopup = false;
      this.isOpen = false;
    },

    isChildActive(child) {
      return (
        this.$route.path === child.path ||
        (child.children &&
          child.children.some(
            (grandChild) => this.$route.path === grandChild.path
          ))
      );
    },
    isActive() {
      return this.$route.path === this.link.path;
    },
    showGroup(children) {
      for (let item of children) {
        if (this.can(item.permission)) {
          return true;
        }
      }
      return false;
    },
    toggleSearchPopup() {
      if (this.showSearchPopup) {
        // Close it
        this.showSearchPopup = false;
        return;
      }

      // Otherwise, close all and open search
      eBus.$emit("close-all-dropdowns");
      this.showSearchPopup = true;
      this.currentOpenGroup = null;
      this.isOpen = true;
    },
    addToFav(item) {
      this.$emit("addToFav", item);
    },
    removeFromFav(item) {
      this.$emit("removeFromFav", item);
    },
    checkItemInFav(path) {
      return this.fav_list.find((data) => data.path === path) || null;
    },
    addToLinkHistory(item) {
      this.$emit("addToLinkHistory", item);
      this.searchQuery = "";
      this.toggleSearchPopup();
    },
    removeSearchResult(index, item) {
      this.filteredSearchResults.splice(index, 1);
      this.$emit("removeSearchResult", item);
    },

    isLinkActive(link) {
      return this.$route.path === link.path;
    },
    handleClickOutside(event) {
      const sidebar = this.$refs.sidebarRef;

      if (sidebar && !sidebar.contains(event.target)) {
        this.closeAll();
      }
    },
    // NEW: Recursive method to check if any descendant has permission
    hasVisibleChildren(children) {
      if (!children || children.length === 0) {
        return false;
      }

      return children.some((child) => {
        // Check if this child has permission (or no permission requirement)
        // we need to check if child permission is defined & is an array or string 
        const isPermissionArray = Array.isArray(child.permission);
        if(isPermissionArray){
          const hasAnyPermission = child.permission.some(perm => this.can(perm));
          if(hasAnyPermission) return true;
        }
        const hasPermission = child.permission ? this.can(child.permission) : true;
        
        if (hasPermission) {
          return true;
        }

        // If child has its own children, check them recursively
        if (child.children && child.children.length > 0) {
          return this.hasVisibleChildren(child.children);
        }

        return false;
      });
    },
  },
  created() {
    eBus.$on("close-all-dropdowns", this.closeAll);
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    // Clean up event listeners
    eBus.$off("dropdown-toggle");
    eBus.$off("school-changed");
    eBus.$off("close-all-dropdowns", this.closeAll);
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>
<style scoped>
.show {
  display: flex !important;
}
</style>